<template>
  <v-dialog :value="value" max-width="560px" @input="$emit('input', $event)">
    <v-card v-if="organization">
      <v-card-title>
        Posible duplicado
        <v-spacer />
        <v-btn icon aria-label="Cerrar" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <p class="mb-3">Estas empresas se parecen. Si son la misma, conviene fusionarlas en Pipedrive.</p>

        <div
          v-for="duplicate in organization.possibleDuplicates"
          :key="duplicate.pipedriveOrgId"
          class="org-duplicate"
        >
          <div class="org-duplicate__pair">
            <div>
              <div class="pw-label">Empresa</div>
              <div class="pw-value">{{ organization.name }}</div>
            </div>
            <div>
              <div class="pw-label">Parecida</div>
              <div class="pw-value">{{ duplicate.name }}</div>
            </div>
          </div>
          <div class="org-duplicate__actions">
            <v-btn small text :disabled="dismissingId === duplicate.pipedriveOrgId" @click="openBoth(duplicate)">
              <v-icon small left>mdi-open-in-new</v-icon>
              Fusionar en Pipedrive
            </v-btn>
            <v-btn small text :loading="dismissingId === duplicate.pipedriveOrgId" @click="dismiss(duplicate)">
              No son la misma
            </v-btn>
          </div>
          <p v-if="openedId === duplicate.pipedriveOrgId" class="org-duplicate__hint mb-0">
            En Pipedrive, abre una y usa Fusionar.
          </p>
        </div>

        <v-alert v-if="errorText" type="error" dense text class="mt-3 mb-0">{{ errorText }}</v-alert>
      </v-card-text>

      <v-card-actions class="pa-4 pt-0">
        <v-spacer />
        <v-btn text @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientOrgChartsService from '../services/client-org-charts.service';
import { errorMessage } from '../utils/org-chart.utils';

export default {
  name: 'DuplicateOrgModal',
  props: {
    value: { type: Boolean, default: false },
    // Fila de la lista: { pipedriveOrgId, name, pipedriveUrl, possibleDuplicates: [...] }
    organization: { type: Object, default: null }
  },
  data() {
    return {
      openedId: null,
      dismissingId: null,
      errorText: ''
    };
  },
  watch: {
    value(open) {
      if (open) {
        this.openedId = null;
        this.errorText = '';
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
    openBoth(duplicate) {
      [this.organization.pipedriveUrl, duplicate.pipedriveUrl].forEach(url => {
        if (url) window.open(url, '_blank', 'noopener');
      });
      this.openedId = duplicate.pipedriveOrgId;
    },
    async dismiss(duplicate) {
      this.dismissingId = duplicate.pipedriveOrgId;
      this.errorText = '';
      const res = await ClientOrgChartsService.dismissDuplicate(this.organization.pipedriveOrgId, duplicate.pipedriveOrgId);
      this.dismissingId = null;
      if (res.status !== 'ok') {
        this.errorText = errorMessage(res, 'No pudimos guardar el cambio. Intenta de nuevo.');
        return;
      }
      // Payload: { pipedriveOrgIdA, pipedriveOrgIdB }
      this.$emit('dismissed', {
        pipedriveOrgIdA: this.organization.pipedriveOrgId,
        pipedriveOrgIdB: duplicate.pipedriveOrgId
      });
      if (this.organization.possibleDuplicates.length <= 1) this.close();
    }
  }
};
</script>

<style scoped>
.org-duplicate {
  padding: 12px 0;
  border-top: 1px solid var(--pw-divider);
}

.org-duplicate__pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.org-duplicate__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 8px;
}

.org-duplicate__hint {
  font-size: 12px;
  color: var(--pw-text-muted);
}
</style>
